import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { getThumbGlobalClassNames } from '../../helpers';
import LiteratureCoverLetter from '../../_partials/HtmlLiteratureCoverLetter';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getDeviationTitle } from '../../../../DeviationViews/_helpers';
var LiteratureMonoHtmlView = function (props) {
    var deviation = props.deviation, link = props.config.link;
    return (React.createElement(EditorDeviationLink, { link: link, deviation: deviation, linkClass: "gallery-link" },
        React.createElement("div", { className: classnames('daeditor-literature-root', getThumbGlobalClassNames(deviation), props.config &&
                props.config.alignment &&
                "daeditor-align-".concat(props.config.alignment), props.settings &&
                props.settings.showMediaAlwaysSmall &&
                "daeditor-small") },
            React.createElement(LiteratureCoverLetter, __assign({}, props)),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "daeditor-literature-title" }, getDeviationTitle(deviation)),
                React.createElement("div", { className: "daeditor-literature-text" }, deviation.textContent && deviation.textContent.excerpt)))));
};
LiteratureMonoHtmlView.displayName = 'LiteratureMonoHtmlView';
export default LiteratureMonoHtmlView;
//# sourceMappingURL=LiteratureHtml.js.map